module.exports = "<div class=\"list-box-wrapper\">\n    <div class=\"list-box\">\n        <div\n             [class.list-box-item]=\"true\"\n             [class.active]=\"(innerValue || {}).id === item.id\"\n             *ngFor=\"let item of list\"\n             (click)=\"innerValue = item\">\n            {{item.caption}}\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-list-box/ui-list-box.html
// module id = 1117
// module chunks = 3